import { type Location } from '#app/types/router.js';
import { createContext } from 'react';

type LocationWithRouteKey = Location & {
  routeKey: string;
};

export const LastLocationContext = createContext<LocationWithRouteKey | null>(
  null,
);
